import { render, staticRenderFns } from "./SitePage.vue?vue&type=template&id=10cac9dc&scoped=true"
import script from "./SitePage.vue?vue&type=script&lang=js"
export * from "./SitePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cac9dc",
  null
  
)

export default component.exports